import basePaymentSchemaFields from "integrations/dromo/paymentSchemaFields";
import { PAID_TO_FORWARDING_ENTITY_PAYMENT_METHOD_OPTIONS } from "common/constants";

export default basePaymentSchemaFields.map((field) => {
  if (field.key === "payment_method_type") {
    return {
      ...field,
      selectOptions: PAID_TO_FORWARDING_ENTITY_PAYMENT_METHOD_OPTIONS,
      description:
        "Payment method (defaults to 'Forwarding Entity' for forwarding agency payments)",
    };
  }
  return field;
});
